/*
 * Copyright 2023 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { JSX } from 'react';
import { IconElement } from '../icons/types';
import { RouteRef } from '../routing/RouteRef';
import { createExtensionDataRef } from './createExtensionDataRef';

/** @public */
export const coreExtensionData = {
  title: createExtensionDataRef<string>().with({ id: 'core.title' }),
  /** An icon element for the extension. Should be exactly 24x24 pixels. */
  icon: createExtensionDataRef<IconElement>().with({ id: 'core.icon' }),
  reactElement: createExtensionDataRef<JSX.Element>().with({
    id: 'core.reactElement',
  }),
  routePath: createExtensionDataRef<string>().with({ id: 'core.routing.path' }),
  routeRef: createExtensionDataRef<RouteRef>().with({ id: 'core.routing.ref' }),
};
